import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { Bundle } from '@paragon/contract-library';

import { productionGroupDeleted } from './productionGroupsSlice';

interface BundlesState {
  [bundleGuid: string]: Bundle;
}

const initialState: BundlesState = {};

const bundlesSlice = createSlice({
  name: 'bundles',
  initialState,
  reducers: {
    bundlesLoaded: (state, action: PayloadAction<readonly Bundle[]>) => {
      for (const bundle of action.payload) {
        state[bundle.guid] = castDraft(bundle);
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(productionGroupDeleted, (state, action) => {
      for (const [batchGuid, batch] of Object.entries(state)) {
        if (batch.productionGroupGuid === action.payload) {
          delete state[batchGuid];
        }
      }
    });
  },
});

export const { bundlesLoaded } = bundlesSlice.actions;
export const bundles = bundlesSlice.reducer;
